import Dialog from '@material-ui/core/Dialog';
import styles from './TeenagePaymentAlertPopup.module.scss';
import Button from 'components/common/Button';
import { JUVELINE_POLICY_URL, useMediaQuery } from 'common/utils';

const TeenagePaymentAlertPopup = ({
  reason,
  setReason,
}: {
  reason: number;
  setReason: (reason: number) => void;
}) => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  if (!reason) return <></>;
  return (
    <Dialog
      open={!!reason}
      maxWidth="lg"
      onClose={() => setReason(null)}
      scroll="body"
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <div className={styles.dialogWrapper}>
        <div className={styles.title}>
          {reason === 1 ? '購入できません' : '上限金額に到達しました'}
        </div>
        {reason === 1 ? (
          <div className={styles.subTitle}>
            １回の購入金額の上限（1万円）{isMobile ? '\n' : ''}
            に達しているため、{'\n'}
            購入できません。
          </div>
        ) : (
          reason === 2 && (
            <div className={styles.subTitle}>
              今月の購入金額の上限（月額3万円）{isMobile ? '\n' : ''}
              に達しているため、{'\n'}
              来月以降にお手続きください。
            </div>
          )
        )}
        <div className={styles.footer}>
          <Button text="閉じる" rounded onClick={() => setReason(null)} />
          {reason === 1 ? (
            <div className={styles.policy}>
              購入金額の上限については、
              {'\n'}「
              <a target="_blank" href={JUVELINE_POLICY_URL}>
                未成年ポリシー
              </a>
              」をご確認ください。
            </div>
          ) : (
            reason === 2 && (
              <div className={styles.policy}>
                お心当たりがない場合は、
                {'\n'}
                <a
                  target="_blank"
                  href="https://help.postprime.com/hc/ja/requests/new?ticket_form_id=6512331197583"
                >
                  サポートデスク
                </a>
                までお問い合わせください。
                {'\n'}
                購入金額の上限については、
                {'\n'}「
                <a target="_blank" href={JUVELINE_POLICY_URL}>
                  未成年ポリシー
                </a>
                」をご確認ください。
              </div>
            )
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default TeenagePaymentAlertPopup;
